// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"b15c208b","787":"90946d04","806":"43f0779d","957":"487d790d"}[chunkId] + ".chunk.js";
};